import { useRef } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { ProductCard } from "@/components/ProductCard";

export const ProductSlider = ({ eyebrow, title, products, brandName, viewAll, testId }) => {
  const scroller = useRef(null);
  const scroll = (dir) => scroller.current?.scrollBy({ left: dir * 640, behavior: "smooth" });

  if (!products?.length) return null;

  return (
    <section className="py-20 border-t border-zinc-200 bg-white" data-testid={testId}>
      <div className="max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between gap-6 mb-10">
          <div>
            {eyebrow && <p className="text-xs uppercase tracking-[0.5em] text-gold mb-3">{eyebrow}</p>}
            <h2 className="font-serif font-medium text-3xl sm:text-4xl text-zinc-900 tracking-tight">{title}</h2>
          </div>
          <div className="flex items-center gap-3">
            {viewAll}
            <div className="hidden md:flex gap-2">
              <button onClick={() => scroll(-1)} data-testid={`${testId}-prev`} aria-label="Previous" className="p-3 border border-zinc-200 text-zinc-500 hover:border-gold hover:text-gold transition-colors duration-300">
                <ChevronLeft size={16} />
              </button>
              <button onClick={() => scroll(1)} data-testid={`${testId}-next`} aria-label="Next" className="p-3 border border-zinc-200 text-zinc-500 hover:border-gold hover:text-gold transition-colors duration-300">
                <ChevronRight size={16} />
              </button>
            </div>
          </div>
        </div>
        <div
          ref={scroller}
          data-testid={`${testId}-scroller`}
          className="flex gap-6 overflow-x-auto snap-x snap-mandatory pb-4 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
        >
          {products.map((p, i) => (
            <div key={p.id} className="w-64 md:w-72 shrink-0 snap-start">
              <ProductCard product={p} brandName={brandName(p.brand_slug)} index={i} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
